import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ style, scrollPx = 0, rowHeight, ...props }) => (
    <div
        {...props}
        style={{
            display: 'flex',
            border: '1px solid #d7d7d7',
            boxSizing: 'border-box',
            alignItems: 'center',
            justifyContent: 'space-around',
            position: 'relative',
            borderWidth: '1px 1px 1px 0',
            zIndex: 1,
            color: '#414141',
            fontFamily: 'roboto',
            fontSize: 15,
            fontWeight: 500,
            backgroundColor: '#ffffff',
            padding: '0 10px',
            height: rowHeight,
            boxShadow:
                scrollPx > 0
                    ? '3px 2px 6px 0 rgba(139,104,70,0.33)'
                    : undefined,
            ...style
        }}
    />
);

const ActionHeader = ({ style, ...props }) => (
    <Header
        {...props}
        style={{
            fontSize: 9,
            borderWidth: 1,
            ...style
        }}
    />
);

const GutterCap = ({ style, ...props }) => (
    <Header
        {...props}
        style={{ borderWidth: '1px 1px 1px 0', gridColumn: 'span 2', ...style }}
    />
);

Header.propTypes = {
    style: PropTypes.object,
    scrollPx: PropTypes.number,
    rowHeight: PropTypes.number
};

ActionHeader.propTypes = {
    style: PropTypes.object,
    scrollPx: PropTypes.number,
    rowHeight: PropTypes.number
};

GutterCap.propTypes = {
    style: PropTypes.object,
    rowHeight: PropTypes.number
};

export { Header, ActionHeader, GutterCap };
